import { render, staticRenderFns } from "./DatosNino.vue?vue&type=template&id=7f93cae2"
import script from "./DatosNino.vue?vue&type=script&lang=js"
export * from "./DatosNino.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports